/**
 * Product Calculator v4
 * Enhanced version with improved UX, mobile optimization, and Shopify best practices
 */
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;

  // Get calculator container
  const calculator = document.querySelector('.calculator-v4');
  if (!calculator) return;

  // Get Liquid data
  window.productCalculatorData = window.productCalculatorData || {};
  const { selectedVariantTitle, selectedVariantPrice, cartCurrency } = window.productCalculatorData;

  // DOM Elements - New v4 selectors
  const selectedProductId = form.querySelector('input[name="id"]');
  const qtyField = form.querySelector('input[name="quantity"]');
  const variantRadios = document.querySelectorAll('#variant-options input[type="radio"]');
  
  // Calculator v4 elements
  const sqftInput = calculator.querySelector('.calculator-v4__sqft-input');
  const quantityInput = calculator.querySelector('.calculator-v4__quantity-input');
  const decreaseBtn = calculator.querySelector('.calculator-v4__qty-btn--decrease');
  const increaseBtn = calculator.querySelector('.calculator-v4__qty-btn--increase');
  const qtyDisplay = calculator.querySelector('.calculator-v4__qty-display');
  const sqftDisplay = calculator.querySelector('.calculator-v4__sqft-display');
  const totalPrice = calculator.querySelector('.calculator-v4__total-price');
  const addToCartBtn = calculator.querySelector('.calculator-v4__add-to-cart');
  const sampleBtn = calculator.querySelector('.calculator-v4__sample-btn');
  
  // Hidden fields for compatibility
  const pricePerSqftBox = document.querySelector('.sqft__per_box');
  const variantPriceInput = document.querySelector('.product__variant_price');
  const floorPriceInput = document.querySelector('.product__floor_price');
  const minQuantityInput = document.querySelector('.product_min_quantity');

  // State variables
  let currentSqft = 0;
  let currentBoxQuantity = 1;
  let boxSqftCoverage = 0;
  let boxPrice = 0;
  let minQuantity = 1;
  let isCalculating = false;

  // Utility functions
  function isMobile() {
    return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  function formatCurrency(value) {
    const currency = cartCurrency || 'USD';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }

  function debounce(func, wait, immediate) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        timeout = null;
        if (!immediate) func.apply(this, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(this, args);
    };
  }

  // Notification system
  let notificationTimeout = null;

  function showNotification(message, type = 'info', duration = 3000) {
    // Remove existing notification
    const existingNotification = document.querySelector('.calculator-v4-notification');
    if (existingNotification) {
      existingNotification.remove();
    }

    // Create new notification
    const notification = document.createElement('div');
    notification.className = `calculator-v4-notification calculator-v4-notification--${type}`;
    notification.textContent = message;
    notification.setAttribute('role', 'alert');
    notification.setAttribute('aria-live', 'polite');

    document.body.appendChild(notification);

    // Auto-remove
    if (notificationTimeout) clearTimeout(notificationTimeout);
    notificationTimeout = setTimeout(() => {
      if (notification && notification.parentNode) {
        notification.style.animation = 'slideOutRight 0.3s ease-in forwards';
        setTimeout(() => {
          if (notification && notification.parentNode) {
            notification.remove();
          }
        }, 300);
      }
    }, duration);
  }

  // Mobile optimizations
  function setupMobileOptimizations() {
    if (isMobile()) {
      // Prevent zoom on focus for iOS
      [sqftInput, quantityInput].forEach(input => {
        if (!input) return;
        
        input.setAttribute('inputmode', 'numeric');
        input.setAttribute('pattern', '[0-9]*');
        
        input.addEventListener('focus', function() {
          const viewport = document.querySelector('meta[name="viewport"]');
          if (viewport) {
            viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
          }
        });
        
        input.addEventListener('blur', function() {
          const viewport = document.querySelector('meta[name="viewport"]');
          if (viewport) {
            viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
          }
        });
      });
    }
  }

  // Load variant metafields
  function loadVariantMetafields(variantId) {
    const variantAttributesElement = document.querySelector('#variant_attributes');
    if (!variantAttributesElement) return null;

    try {
      const variantMetafields = JSON.parse(variantAttributesElement.dataset.variants);
      return variantMetafields[variantId] || null;
    } catch (error) {
      console.error('Error parsing variant metafields:', error);
      return null;
    }
  }

  // Update calculator with variant data
  function updateCalculatorWithVariant(variantId) {
    const metafields = loadVariantMetafields(variantId);
    if (!metafields) return;

    // Update variant attributes data
    document.querySelector("#variant_attributes")?.setAttribute("data-selected-variant", variantId);

    // Update state variables
    boxSqftCoverage = parseFloat(metafields.boxQuantity) || 10;
    boxPrice = parseFloat(metafields.boxPrice) || 0; // Box price from metafields (should be in dollars)
    minQuantity = parseInt(metafields.minQuantity) || 1;
    
    // Ensure current quantity meets minimum requirement
    if (currentBoxQuantity < minQuantity) {
      currentBoxQuantity = minQuantity;
    }
    
    // If boxPrice seems to be in cents (very large number), convert to dollars
    if (boxPrice > 1000) {
      boxPrice = boxPrice / 100;
    }
    
    // If boxPrice is still 0 or seems incorrect, use the Shopify variant price as fallback
    if (boxPrice <= 0 && selectedVariantPrice) {
      boxPrice = selectedVariantPrice / 100; // Convert Shopify cents to dollars
    }

    // Update hidden fields for compatibility
    if (pricePerSqftBox) pricePerSqftBox.value = boxSqftCoverage;
    if (variantPriceInput) variantPriceInput.value = boxPrice;
    if (floorPriceInput) floorPriceInput.value = metafields.sqFtPrice || 0;
    if (minQuantityInput) minQuantityInput.value = minQuantity;

    // Update specifications display
    updateSpecificationsDisplay(metafields);

    // Update image comparison
    updateImageComparison(metafields);

    // Update in-stock availability notice
    updateStockNotice(metafields);

    // Update price display with discount handling
    updatePriceDisplay(metafields);

    // Update sample buttons
    updateSampleButtons(metafields);

    // Update quantity input attributes
    updateQuantityInputs();
    // Update displays and recalculate
    updateDisplays();
    calculateTotal();
    
    // Trigger custom event for other components
    window.dispatchEvent(new CustomEvent('variant:changed', { 
      detail: { 
        variantId, 
        metafields,
        samplePrice: metafields.sample_price || window.productCalculatorData?.samplePrice || '$2.99'
      } 
    }));
  }

  // Update specifications display
  function updateSpecificationsDisplay(metafields) {
    const productMetaGroup = document.querySelector("#product_item__meta-group");
    if (!productMetaGroup) return;

    let specificationsHtml = "";
    if (metafields.specifications && metafields.specifications.children) {
      specificationsHtml += "<ul>";
      
      metafields.specifications.children[0].children.forEach(item => {
        const boldText = item.children[0]?.value || "";
        const normalText = item.children[1]?.value || "";
        specificationsHtml += `<li><strong>${boldText}</strong> ${normalText}</li>`;
      });
      
      specificationsHtml += "</ul>";
    } else {
      specificationsHtml = "<p>No specifications available.</p>";
    }
    
    productMetaGroup.innerHTML = specificationsHtml;
  }

  // Update image comparison
  function updateImageComparison(metafields) {
    const imageComparison = document.querySelector("#image__size__comparison");
    if (imageComparison && metafields.variantImageSizeComparison) {
      const productMetaDetailsContainer = document.querySelector("#product-meta-details-container");
      if (productMetaDetailsContainer) {
        productMetaDetailsContainer.style.display = "block";
      }
      imageComparison.setAttribute("src", metafields.variantImageSizeComparison);
    }
  }

  // Separate function to update add to cart button state
  function updateAddToCartButtonState(isOutOfStock, stockStatus = null) {
    const addToCartBtn = document.querySelector('.calculator-v4__add-to-cart');
    if (addToCartBtn) {
      if (isOutOfStock) {
          addToCartBtn.textContent = stockStatus || "SOLD OUT";
          addToCartBtn.setAttribute("data-button-label", stockStatus);

        if (stockStatus === "PRE-ORDER NOW") {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove("disabled");
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.classList.add("disabled");
        }
      } else {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = "ADD TO CART";
       
        addToCartBtn.classList.remove("disabled");
      }
    }
  }  

  // Update stock notice based on variant metafields
  function updateStockNotice(metafields) {
    const stockStatusElement = document.querySelector(".stock-status-v4");
    const deliveryInfoElement = document.querySelector(".delivery-info-v4");
    
    // Get stock status from variant attributes, default to "In-Stock"
    let stockStatusMetafield = metafields.stockStatus;
    
    // Handle array format metafields like ["Re-Stock"]
    if (Array.isArray(stockStatusMetafield) && stockStatusMetafield.length > 0) {
      stockStatusMetafield = stockStatusMetafield[0];
    }
    
    if (!stockStatusMetafield || stockStatusMetafield.trim() === "") {
      stockStatusMetafield = "In-Stock";
    }
    const restockNotice = metafields.restockNotice;
    
    // Default values
    let stockStatus = "In Stock";
    let deliveryInfo = "Estimated Delivery Time 5 - 7 Business Days";
    let isAvailable = "in-stock";
    let isOutOfStock = false;
    
    // Handle different stock status types
    switch (stockStatusMetafield) {
      case "In-Stock":
        stockStatus = "In Stock";
        deliveryInfo = "Estimated Delivery Time 5 - 7 Business Days";
        isAvailable = "in-stock";
        isOutOfStock = false;
        break;
      case "Out-of-Stock":
        stockStatus = "OUT OF STOCK";
        deliveryInfo = restockNotice;
        isAvailable = "out-of-stock";
        isOutOfStock = true;
        break;
      case "Re-Stock":
        stockStatus = "Out of Stock";
        deliveryInfo = restockNotice;
        isAvailable = "re-stock";
        isOutOfStock = true;
        break;
      case "Coming":
        stockStatus = "Out of Stock";
        deliveryInfo = restockNotice;
        isAvailable = "coming";
        isOutOfStock = true;
        break;
      default:
        // Fallback to old logic for backward compatibility
        if (metafields.restockNotice && metafields.restockNotice.trim() !== "") {
          stockStatus = "OUT OF STOCK";
          deliveryInfo = metafields.restockNotice;
          isAvailable = "out-of-stock";
          isOutOfStock = true;
        }
        break;
    }
    
    // Check variant availability from Shopify for button state only
    let isVariantUnavailable = metafields.available === false || metafields.available === "false";
    
    // Update stock status elements if they exist
    if (stockStatusElement) {
      stockStatusElement.textContent = stockStatus;
      stockStatusElement.className = `stock-status-v4 ${isAvailable}`;
    }
    
    if (deliveryInfoElement) {
      deliveryInfoElement.textContent = deliveryInfo;
    }
    
    // Update add to cart button state
    let buttonShouldBeDisabled = isOutOfStock || isVariantUnavailable;
    let buttonText = null;
    
    if (isOutOfStock) {
      // Use "SOLD OUT" for Out-of-Stock and Re-Stock, keep original text for Coming
      if (stockStatusMetafield === "Out-of-Stock") {
        buttonText = "SOLD OUT";
      } else {
        buttonText = "PRE-ORDER NOW"; // For "Coming" status
      }
    } else if (isVariantUnavailable) {
      buttonText = "SOLD OUT";
    }
    
    updateAddToCartButtonState(buttonShouldBeDisabled, buttonText);
  }
  
  // Update price display with discount handling
  function updatePriceDisplay(metafields) {
    const priceContainer = document.querySelector(".prices__container-v4 .price-v4");
    const regularPrice = document.querySelector(".prices__container-v4 .price__slash-v4");
    const discountPercentTag = document.querySelector(".prices__container-v4 .price__discount-badge-v4");
    if (priceContainer) {
      const sqFtPrice = metafields.sqFtPrice;           // e.g. 100
      const discountPercent = metafields.discountPrice; // e.g. 20 (means 20% off)

      if (!discountPercent) {
        priceContainer.textContent = `$${sqFtPrice}/sq ft`;
        if (discountPercentTag) {
          discountPercentTag.style.display = 'none';
        }
      } else {
        if (regularPrice) {
          regularPrice.textContent = `$${sqFtPrice}/sq ft`;
        }
        priceContainer.textContent = `$${metafields.discountPriceSqft}/sq ft`;
        if (discountPercentTag) {
          discountPercentTag.textContent = `Save ${parseFloat(discountPercent).toFixed()}%!`;
        }
      }
    }
  }

  // Update sample buttons
  function updateSampleButtons(metafields) {
    const sampleButtons = document.querySelectorAll("#get-sample-form-btn, #get-sample-form-v4-btn, .get-sample-form-btn-cls-v4");
    const sampleContainers = document.querySelectorAll("#get-sample-form, #get-sample-form-v4, .section__add_to_cart__sample, .section__add_to_cart__sample-v4");
    
        // Check if sample stock is available and sample ID exists
    // sample_stock comes as a string from Liquid template
    const hasSampleStock = metafields.sample_stock && 
                          metafields.sample_stock !== '' && 
                          metafields.sample_stock !== 'false' &&
                          metafields.sample_stock !== 'null';
    const hasSampleId = metafields.sid && metafields.sid !== '';
    const shouldShowSample = hasSampleStock && hasSampleId;


    
    // Show or hide sample containers
    sampleContainers.forEach(container => {
      if (container) {
        container.style.display = shouldShowSample ? 'block' : 'none';
      }
    });
    
    // Update sample buttons if they should be shown
    if (shouldShowSample) {
      sampleButtons.forEach(button => {
        if (button) {
          button.dataset.id = metafields.sid;
          button.dataset.title = metafields.title;
          button.dataset.quantity = "1";
          
          // Update button text with sample price from metafields
          const buttonText = button.querySelector('.button-text');
          if (buttonText) {
            const samplePrice = metafields.sample_price || window.productCalculatorData?.samplePrice || '$2.99';
            buttonText.textContent = `TRY A SAMPLE FOR - ${samplePrice}`;
          }
          
          // Enable button
          button.disabled = false;
          button.style.pointerEvents = 'auto';
          button.style.opacity = '1';
        }
      });
    } else {
      // Disable sample buttons if no sample available
      sampleButtons.forEach(button => {
        if (button) {
          button.disabled = true;
          button.style.pointerEvents = 'none';
          button.style.opacity = '0.5';
        }
      });
    }
  }

  // Update quantity input attributes
  function updateQuantityInputs() {
    // Update form quantity field
    if (qtyField) {
      qtyField.setAttribute("min", minQuantity);
      qtyField.value = currentBoxQuantity;
    }
    
    // Update calculator quantity input
    if (quantityInput) {
      quantityInput.setAttribute("min", minQuantity);
      quantityInput.value = currentBoxQuantity;
    }
  }

  // Calculate boxes needed from square feet
  function calculateBoxesFromSqft(sqft) {
    if (!sqft || sqft <= 0) return minQuantity;
    return Math.max(minQuantity, Math.ceil(sqft / boxSqftCoverage));
  }

  // Update all displays
  function updateDisplays() {
    if (qtyDisplay) {
      qtyDisplay.textContent = currentBoxQuantity;
    }
    if (sqftDisplay) {
      sqftDisplay.textContent = `${(currentBoxQuantity * boxSqftCoverage).toFixed(2)} Sq Ft`;
    }
    
    // Update quantity input
    if (quantityInput) {
      quantityInput.value = currentBoxQuantity;
    }
    
    // Update form quantity field
    if (qtyField) {
      qtyField.value = currentBoxQuantity;
    }

    // Update button states
    updateButtonStates();
  }

  // Update button states
  function updateButtonStates() {
    if (decreaseBtn) {
      decreaseBtn.disabled = currentBoxQuantity <= minQuantity;
    }
    if (increaseBtn) {
      increaseBtn.disabled = false; // No maximum restriction
    }
  }

  // Calculate and update total price
  function calculateTotal() {
    const total = currentBoxQuantity * boxPrice;
    if (totalPrice) {
      totalPrice.textContent = formatCurrency(total);
    }
  }

  // Handle square feet input
  function handleSqftInput() {
    if (!sqftInput) return;

    const debouncedCalculation = debounce(() => {
      const sqft = parseFloat(sqftInput.value) || 0;
      
      currentSqft = sqft;
      
      if (sqft > 0) {
        // Calculate boxes needed: sqft / coverage per box, rounded up
        const calculatedBoxes = calculateBoxesFromSqft(sqft);
        currentBoxQuantity = calculatedBoxes;
      } else {
        currentBoxQuantity = minQuantity;
      }

      updateDisplays();
      calculateTotal();
      isCalculating = false;
    }, 300);

    // Input event with debouncing
    sqftInput.addEventListener('input', () => {
      isCalculating = true;
      debouncedCalculation();
    });

    // Immediate calculation on blur and Enter
    sqftInput.addEventListener('blur', () => {
      if (isCalculating) {
        debouncedCalculation.flush?.();
      }
    });

    sqftInput.addEventListener('keyup', (e) => {
      if (e.key === 'Enter' || e.keyCode === 13) {
        sqftInput.blur();
      }
    });
  }

  // Handle quantity input
  function handleQuantityInput() {
    if (!quantityInput) return;

    function validateAndUpdateQuantity(value) {
      let qty = parseInt(value) || minQuantity;
      
      if (qty < minQuantity) {
        qty = minQuantity;
        showNotification(`Minimum quantity is ${minQuantity}`, 'warning');
      }

      currentBoxQuantity = qty;
      updateDisplays();
      calculateTotal();
    }

    quantityInput.addEventListener('input', (e) => {
      validateAndUpdateQuantity(e.target.value);
    });

    quantityInput.addEventListener('blur', (e) => {
      validateAndUpdateQuantity(e.target.value);
    });
  }

  // Handle quantity buttons
  function handleQuantityButtons() {
    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', () => {
        if (currentBoxQuantity > minQuantity) {
          currentBoxQuantity--;
          updateDisplays();
          calculateTotal();
        }
      });
    }

    if (increaseBtn) {
      increaseBtn.addEventListener('click', () => {
        currentBoxQuantity++;
        updateDisplays();
        calculateTotal();
      });
    }
  }

  // Handle add to cart
  function handleAddToCart() {
    if (!addToCartBtn || !selectedProductId) return;

    addToCartBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      
      // Show loading state
      addToCartBtn.classList.add('loading');
      addToCartBtn.disabled = true;

      try {
        const formData = {
          items: [{
            id: selectedProductId.value,
            quantity: currentBoxQuantity
          }]
        };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        const result = await response.json();
        
        // Update cart count
        await updateCartCount();
        
        // Show success state
        addToCartBtn.textContent = 'ADDED TO CART!';
        showNotification('Item added to cart successfully!', 'success');
        
        // Reset button after 3 seconds
        setTimeout(() => {
          addToCartBtn.textContent = 'ADD TO CART';
          addToCartBtn.classList.remove('loading');
          addToCartBtn.disabled = false;
        }, 3000);

      } catch (error) {
        console.error('Unable to add item to cart:', error);
        showNotification('Failed to add item to cart. Please try again.', 'error');
        
        // Reset button
        addToCartBtn.classList.remove('loading');
        addToCartBtn.disabled = false;
      }
    });
  }

  // Update cart count
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Update cart count elements
      const cartCountElements = document.querySelectorAll('.js-cart-count');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
      });

      // Update cart icon state
      const cartIcons = document.querySelectorAll('.js-cart-icon');
      cartIcons.forEach(icon => {
        if (cart.item_count > 0) {
          icon.classList.add('js-cart-full');
        } else {
          icon.classList.remove('js-cart-full');
        }
      });
    } catch (error) {
      console.error('Unable to fetch cart data:', error);
    }
  }

  // Handle sample button
  function handleSampleButton() {
    if (!sampleBtn) return;

    sampleBtn.addEventListener('click', () => {
      // Get sample variant ID from metafields
      const metafields = loadVariantMetafields(selectedProductId?.value);
      if (metafields?.sid) {
        // Add sample to cart logic
        const sampleFormData = {
          items: [{
            id: metafields.sid,
            quantity: 1
          }]
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(sampleFormData),
        })
        .then(response => response.json())
        .then(result => {
          showNotification('Sample added to cart!', 'success');
          updateCartCount();
        })
        .catch(error => {
          console.error('Unable to add sample to cart:', error);
          showNotification('Failed to add sample to cart.', 'error');
        });
      }
    });
  }

  // Handle variant changes
  function handleVariantChange() {
    if (!selectedProductId) return;

    let lastProductId = selectedProductId.value;

    function onVariantChange() {
      const currentValue = selectedProductId.value;
      
      if (currentValue !== lastProductId) {
        lastProductId = currentValue;
        updateCalculatorWithVariant(currentValue);
        
        // Reset inputs
        if (sqftInput) sqftInput.value = '';
        currentSqft = 0;
        
        // Preserve current quantity if it's above the new minimum, otherwise use minimum
        if (currentBoxQuantity < minQuantity) {
          currentBoxQuantity = minQuantity;
        }
        
        updateDisplays();
        calculateTotal();
      }
    }

    // Watch for variant changes
    const observer = new MutationObserver(onVariantChange);
    observer.observe(selectedProductId, {
      attributes: true,
      attributeFilter: ['value'],
    });

    // Handle radio button changes
    variantRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        if (this.checked) {
          selectedProductId.value = this.value;
          onVariantChange();
        }
      });
    });
  }

  // Initialize calculator
  function initializeCalculator() {
    // Setup mobile optimizations
    setupMobileOptimizations();
    
    // Get initial quantity from the input field (set by liquid template)
    if (quantityInput) {
      currentBoxQuantity = parseInt(quantityInput.value) || 1;
      minQuantity = parseInt(quantityInput.getAttribute('min')) || 1;
    }
    
    // Load initial variant data
    if (selectedProductId?.value) {
      updateCalculatorWithVariant(selectedProductId.value);
    } else if (selectedVariantPrice) {
      // Fallback: use the price from liquid data if no variant ID
      boxPrice = selectedVariantPrice / 100; // Convert from cents to dollars
      calculateTotal();

      // Update button state based on initial Liquid template state
      const initiallyDisabled = addToCartBtn?.disabled || addToCartBtn?.hasAttribute('disabled');
      if (initiallyDisabled) {
        updateAddToCartButtonState(true, addToCartBtn.textContent || "SOLD OUT");
      }      
    }
    
    // Set up event handlers
    handleSqftInput();
    handleQuantityInput();
    handleQuantityButtons();
    handleAddToCart();
    handleSampleButton();
    handleVariantChange();
    
    // Initial display update
    updateDisplays();
    calculateTotal();
  }

  // Start the calculator
  initializeCalculator();
}); 